import { useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { apiError } from "@/lib/api";
import { AlertTriangle, Lock } from "lucide-react";

export default function Login() {
  const { login, pilot } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/");
    } catch (err) {
      setError(apiError(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-slate-900 flex flex-col items-center justify-center px-4">
      {pilot && (
        <div className="fixed top-0 left-0 w-full bg-amber-400 text-slate-950 px-4 py-1.5 text-center text-xs sm:text-sm font-bold uppercase flex items-center justify-center gap-2" data-testid="pilot-banner">
          <AlertTriangle className="h-4 w-4" /> PILOT — date de test, cu denumiri fictive
        </div>
      )}
      <div className="w-full max-w-sm" data-testid="login-container">
        <div className="flex items-center gap-3 mb-8 justify-center">
          <div className="h-10 w-10 rounded bg-[#FFC800] flex items-center justify-center font-display font-extrabold text-slate-950 text-lg">
            J
          </div>
          <div>
            <div className="font-display font-bold text-white text-lg leading-tight">Portal Jungheinrich</div>
            <div className="text-slate-400 text-xs">Financiar & Controlling</div>
          </div>
        </div>
        <form
          onSubmit={submit}
          className="bg-slate-800 border border-slate-700 rounded-md p-6 space-y-4"
        >
          <div className="flex items-center gap-2 text-slate-200 font-medium mb-2">
            <Lock className="h-4 w-4" /> Autentificare
          </div>
          <div className="space-y-1.5">
            <Label htmlFor="email" className="text-slate-300 text-xs uppercase tracking-wider">
              Utilizator sau email
            </Label>
            <Input
              id="email"
              data-testid="login-email-input"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="bg-slate-900 border-slate-700 text-white focus:ring-2 focus:ring-[#FFC800]"
              autoComplete="username"
            />
          </div>
          <div className="space-y-1.5">
            <Label htmlFor="password" className="text-slate-300 text-xs uppercase tracking-wider">
              Parolă
            </Label>
            <Input
              id="password"
              type="password"
              data-testid="login-password-input"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="bg-slate-900 border-slate-700 text-white focus:ring-2 focus:ring-[#FFC800]"
              autoComplete="current-password"
            />
          </div>
          {error && (
            <div data-testid="login-error" className="text-sm text-red-400 bg-red-950/40 border border-red-900 rounded px-3 py-2">
              {error}
            </div>
          )}
          <Button
            type="submit"
            data-testid="login-submit-button"
            disabled={loading}
            className="w-full bg-[#FFC800] text-slate-950 hover:bg-[#E6B200] font-semibold"
          >
            {loading ? "Se conectează…" : "Intră în cont"}
          </Button>
        </form>
      </div>
    </div>
  );
}
